import Vue from "@src/libraries/vue";
import LoginDialog from "@src/components/modals/login.vue";
import localesStore from "@src/store/locales";
import usersStore from "@src/store/users";
import clientStore from "@/store/client";
export default Vue.extend({
    name: "DefaultLayout",
    components: {
        LoginDialog,
    },
    data() {
        return {
            drawer: false,
            activeBtn: "",
        };
    },
    computed: {
        alias() {
            return clientStore.alias;
        },
        adminLink() {
            const alias = this.alias;
            return localesStore.localePath(`${alias}/home`);
        },
        activityLink() {
            const alias = this.alias;
            return localesStore.localePath(`${alias}/activity`);
        },
        configurationLink() {
            const alias = this.alias;
            return localesStore.localePath(`${alias}/configuration`);
        },
    },
    methods: {
        logout() {
            usersStore.logout();
            this.$router.push("/");
        },
    },
});
